import { FC } from "react";

import { CheckIcon } from "@chakra-ui/icons";
import { Box, HStack } from "@chakra-ui/react";

import { Typography, EmptyWrapper } from "@components/common";
import { LinkWrapper } from "@components/Link";

import HtmlLinkWrapper from "./HtmlLinkWrapper";
import { TStepNodeProps } from "./types";

const StepNode: FC<TStepNodeProps> = ({
  isComplete,
  isPreviousOrCurrentStep,
  styles,
  isPreviousStep,
  stepNumber,
  href,
  onClick,
  label,
}) => {
  const OptionalHtmlLink = href ? HtmlLinkWrapper : EmptyWrapper;
  return (
    <LinkWrapper href={href}>
      <OptionalHtmlLink>
        <HStack spacing="0.875rem" style={{ maxHeight: "1.875rem" }}>
          <Box
            sx={isComplete || isPreviousOrCurrentStep ? styles.stepActive : styles.step}
            onClick={onClick}
            {...((onClick || href) && { cursor: "pointer" })}
          >
            {isComplete || isPreviousStep ? (
              <CheckIcon />
            ) : (
              <Typography
                type="small"
                sx={{
                  color: isPreviousOrCurrentStep ? "white" : "dpd-black",
                }}
              >
                {stepNumber}
              </Typography>
            )}
          </Box>
          {label && (
            <Typography type="small" fontWeight={isComplete || isPreviousOrCurrentStep ? "bold" : "medium"}>
              {label}
            </Typography>
          )}
        </HStack>
      </OptionalHtmlLink>
    </LinkWrapper>
  );
};
export default StepNode;
